<template>
  <div>
    <TeacherActivePageTableControl v-if="type === 1" />
    <TeacherArchivedPageTableControl v-if="type === 2" />
  </div>
</template>

<script>
import TeacherActivePageTableControl from "@/modules/school/components/teacher/filter/TeacherActivePageTableControl";
import TeacherArchivedPageTableControl from "@/modules/school/components/teacher/filter/TeacherArchivedPageTableControl";
export default {
  name: "TeacherPageTableControl",
  components: {
    TeacherArchivedPageTableControl,
    TeacherActivePageTableControl,
  },
  data() {
    return {
      type: null,
    };
  },
  mounted() {
    this.checkRoute(this.$route.name);
  },
  methods: {
    checkRoute(name) {
      switch (name) {
        case "teacherActiveList":
          this.type = 1;
          break;
        case "teacherArchivedList":
          this.type = 2;
          break;
        default:
          this.type = 3;
          break;
      }
    },
  },
  watch: {
    $route(to, from) {
      console.log(to, from);

      this.checkRoute(to.name);
    },
  },
};
</script>

<style scoped></style>
